export const EmptyCell = (): null => null;
